import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/laravel': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M637.5 241.6c4.3 4.8 3.2 8.6-4.7 10.6-6.7 1.9-69.6 18.6-87.3 23.3 25.8 34.6 75.1 100.6 79.3 106.8 5.7 8.5 0.5 10.9-7.9 14.4-8.4 3.4-195.2 70.6-208 74.5-16.3 5-23.7 7.5-34.3-7.4-8-11.1-51.1-88.7-72.2-127-40 10.5-113.2 29.6-134.3 34.7-20.6 5-29.4-7.4-32.8-15-3.4-7.6-124.8-269.2-132.4-287.2-7.6-18 0.8-21.4 8.4-22 7.6-0.7 114.5-9.6 128.5-10.2 14-0.7 15.3 2.5 21.4 11.6l154.2 257.5 193.7-46.4c-10.8-15.2-59.5-84.3-64.2-90.9-5.3-7.4 0.1-10.8 8.7-12.3 8.6-1.4 82.7-13.9 89.1-14.8 6.3-0.9 11.4-3.1 21.7 9.3 10.3 12.4 68.9 85.7 73.1 90.5zM285.3 313.6c2.3-0.5 3.8-1.8 1.2-6.1-2.4-4.3-144.6-249.7-144.6-249.7-1.3-2.2-0.9-3-4.5-2.8-3.5 0.2-104.3 9.2-106 9.2-1.7 0-1.8 2.6 0 5.9 1.8 3.3 130.1 268 130.8 270s0.7 2.6 6.5 1.3c5.8-1.3 114.3-27.3 116.6-27.8zM591.3 371c-1.7-2.7-61.2-83.4-64.1-88.2-3-4.7-4.5-3.7-9.2-2.2l-188.8 49.1s58 100.3 62.4 106.8c4.4 6.5 7.1 6 10.6 4.5 3.4-1.5 181.7-61.6 187.1-63.6 5.5-1.9 3.7-3.7 2-6.4zM603.4 236.9c4.2-1 7.4-2.4 5.6-4.7-1.9-2.4-50.9-64.5-54.5-69.4-3.6-4.9-6.1-4.1-9-3.4-2.9 0.6-67.3 12.3-71.3 12.8s-2.7 2.7-1.1 5l56.7 77.8s69.4-17.2 73.6-18.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/laravel.js
// module id = 909
// module chunks = 0